import * as React from "react";
import { SVGProps, memo } from "react";

const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.5 21.035 8.535-8.535h21.93l8.535 8.535v21.93L42.965 51.5h-21.93L12.5 42.965v-21.93ZM20.828 7.5a4.5 4.5 0 0 0-3.182 1.318l-8.828 8.828A4.5 4.5 0 0 0 7.5 20.828v22.344a4.5 4.5 0 0 0 1.318 3.182l8.828 8.828a4.5 4.5 0 0 0 3.182 1.318h22.344a4.5 4.5 0 0 0 3.182-1.318l8.828-8.828a4.5 4.5 0 0 0 1.318-3.182V20.828a4.5 4.5 0 0 0-1.318-3.182l-8.828-8.828A4.5 4.5 0 0 0 43.172 7.5H20.828ZM32 19a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-5 0v-11A2.5 2.5 0 0 1 32 19Zm3 22.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      fill="#B5B5B5"
    />
  </svg>
);

const Memo = memo(SvgError);

export default Memo;
